<template lang="pug">
  .checkbox(:class="classes")
    label.checkbox__label
      input.checkbox__control(v-model="inputValue", @change="handleChange", :placeholder="input.placeholder", ref="checkbox", v-validate="input.validateRules", :name="input.name", :disabled="disabled" type="checkbox")
      span.checkbox__text(v-text="input.text")
      
    //- a.input__popup-trigger(v-if="input.hasPopup", href="#", @click.prevent="popupTriggerClickHandle")
      img.input__popup-trigger-pic(src="img/popup-trigger.svg")
    .checkbox__error
      |{{errors.first(input.name)}}
    //- .input__desc(v-if="input.hasDescription")
    //-   |Например
    //-   a.input__desc-link(href="#", @click.prevent)
    //-     |{{descLink}}
    //- .input__error(v-if="isError")
      |{{errors.first(input.name)}}


</template>

<script>
  import Inputmask from 'inputmask';
export default {

  inject: ['$validator'],
  props:{
    input: null,
    field: null,
    disabled: {
      default:false,
      required:false
    }
  },
  name: 'app-checkbox',
  components: {
    
  },
  data() {
    return {
      // inputValue:'',
    }
  },
  mounted() {
    
    
  },
  methods:{
    handleChange(){
      this.$emit('handleChange');
    },
  },
  computed:{
    inputValue: {
      get() {
          return this.field;
      },

      set(field) {
          this.$emit('update:field', field);
          this.$emit('handleChange', field);
      }
    },
    isError() {
      
      return this.errors.has(this.input.name);
    },
    isEmpty() {
      if (this.inputValue) {
          return false;
      } else {
          return true;
      }
    },
    classes() {
      return {
        'is_status-error': this.isError,
        'is_status-valid': !this.isEmpty && !this.isError,
        'is_status-disabled': this.isDisabled
      };
    }
    // ...mapGetters({
    //   sportList: 'getSportList',
    //   sportTariffs: 'getSportTariffs',
    // })
  }
}
</script>

<style lang="scss">
  .checkbox {
    &__label {
      display: flex;
    }

    &__control {
    position: relative;

    &:before {
      content: '';
      position: absolute;
      right: 0;
      top: 0;
      width: 30px;
      height: 30px;
      border: 1px solid #e0e1e2;
    }
    }
  
  }

</style>
